import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {
  "slug": "stats",
  "title": "Competitività",
  "pretitle": "",
  "image": "../images/notes.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Conosciamo le esigenze del mercato e vi veniamo incontro con prezzi e servizi competitivi.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      